import { useMemo } from 'react'
import { useListThreatProfilesQuery, useGetThreatProfileQuery } from './profiles'
import { useSelectedThreatProfileStorage } from './useSelectedThreatProfileStorage'

export const useSelectedThreatProfileQuery = (options = {}) => {
  const { data: listData, isLoading: listIsLoading } = useListThreatProfilesQuery()
  const [storedId] = useSelectedThreatProfileStorage()

  const selectedId = useMemo(() => {
    if (!listData?.profiles?.length) {
      return
    }
    // Ensure the storedId is accessible to this user. If so, return it.
    if (listData.profiles.some(profile => profile.name === storedId)) {
      return storedId
    }
    // If not, return the first accessible profile name if it exists
    return listData.profiles[0].name
  }, [listData, storedId])

  const unavailable = !listIsLoading && !selectedId
  const profileResponse = useGetThreatProfileQuery(selectedId, options)

  if (unavailable) {
    return { data: null, isLoading: false }
  }

  return profileResponse
}
